<template>
  <div class="comment">
    <!-- 评论容器 -->
    <div class="comment-container" id="article-comment-box" ref="commentRef">
      <ss-comment-block
        class="comment-reply-wrapper"
        :login="isLogin"
        :user="userInfo"
        :commentable="allowComment && !isBanned && (articleInfo.is_free || articleInfo.user_is_pay)"
        :commentWithPicture="commentFileOn"
        :reason="reason"
        :keywords-illegal="keywordsIllegal"
        @toLogin="toLogin"
        @submit="onSubmitComment"
      >
        <template v-if="!isBanned && !articleInfo.is_free && !articleInfo.user_is_pay" slot="not-commentable">
          <span class="text">购买栏目方可评论，</span><a class="join" :href="articleInfo.series.page_redirect_url || `/series/${articleInfo.series.id}`">立即购买</a>
        </template>
      </ss-comment-block>

      <div class="comment-list-wrapper">
        <!-- 评论 -->
        <template v-for="(comment, pIndex) in comments">
          <div :key="comment.id" class="comment-item-wrapper">
            <div class="comment-parent-wrapper">
              <ss-comment-item
                :id="`comment-${comment.id}`"
                class="comment-item-inner-wrapper"
                :login="isLogin"
                :userInfo="userInfo"
                :terminalType="terminalType"
                :comment="comment"
                :index="pIndex"
                :allow-comment="allowComment"
                :base-permission="!isBanned"
                :manage-permission="managePermission"
                :commentable="getCommentPermission(comment, comment)"
                :deletable="getDeletePermission(comment)"
                :can-chosen="true"
                :can-top="true"
                :whitelist="setting.external_links_whitelist"
                @reply="emitReply"
                @like="emitLike"
                @dislike="emitLike"
                @report="emitReport"
                @delete="emitDelete"
                @toLogin="toLogin"
                @click.native.stop
                :showUserCard="false"
              >
              </ss-comment-item>
            </div>
            <div class="comment-children-wrapper">
              <template v-for="(childComment, cIndex) in comment.reply">
                <ss-comment-item
                  :key="childComment.id"
                  :id="`comment--${childComment.id}`"
                  class="comment-item-inner-wrapper"
                  :login="isLogin"
                  :userInfo="userInfo"
                  :terminalType="terminalType"
                  :comment="childComment"
                  :parent="comment"
                  :index="cIndex"
                  :parent-index="pIndex"
                  :allow-comment="allowComment"
                  :base-permission="!isBanned"
                  :manage-permission="managePermission"
                  :commentable="getCommentPermission(childComment, comment)"
                  :deletable="getDeletePermission(childComment, comment)"
                  :can-chosen="false"
                  :can-top="false"
                  :whitelist="setting.external_links_whitelist"
                  @reply="emitReply"
                  @like="emitLike"
                  @dislike="emitLike"
                  @report="emitReport"
                  @delete="emitDelete"
                  @toLogin="toLogin"
                  @click.native.stop
                  :showUserCard="false"
                >
                </ss-comment-item>
              </template>
            </div>
            <transition name="el-zoom-in-top">
              <div
                v-if="replyToComment && replyToComment.comment && (replyToComment.comment.id === comment.id || replyToComment.parentId === comment.id)"
                class="comment-child-reply-wrapper">
                <ss-comment-block
                  button-label="回复"
                  :login="isLogin"
                  :user="userInfo"
                  :user-reply-to="replyToComment.comment.user"
                  :commentable="allowComment"
                  :commentWithPicture="commentFileOn"
                  :reason="reason"
                  :keywords-illegal="keywordsIllegal"
                  :initial-focus="true"
                  :initial-value="replyToComment.value"
                  @change="onChange"
                  @toLogin="toLogin"
                  @submit="onSubmitReply"
                  @blur="commentBlur"
                >
                </ss-comment-block>
              </div>
            </transition>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
// import anchorPoint from '../../anchorPoint.js'

export default {
  name: 'comment',

  props: {
    articleInfo: Object,
    articleType: {
      type: String,
      required: true
    },
    comments: Array
  },

  data () {
    return {
      keywordsIllegal: [],
      replyToComment: {
        parentId: 0,
        comment: null,
        value: ''
      }
    }
  },

  computed: {
    ...mapState(['userInfo', 'terminalType', 'isLogin', 'setting']),
    commentFileOn () {
      // 是否开通图片评论
      return this.articleInfo.comment_file_on
    },
    isFreeArticle () {
      // 是否为免费文章
      if (this.articleInfo) {
        return this.articleInfo.is_free === 1 || this.articleInfo.is_free === true
      }
      return false
    },
    isRecommendToHome () {
      // 是否为首页推荐文章
      if (this.articleInfo) {
        return this.articleInfo.article_type === 0
      }
      return false
    },
    isAuthor () {
      // 当前登录的用户是否为文章作者
      if (this.articleInfo && this.userInfo) {
        return this.userInfo.slug === this.articleInfo.author.slug
      }
      return false
    },
    isSeriesArticle () {
      // 是否为栏目文章
      if (this.articleInfo) {
        return this.articleInfo.series && !!this.articleInfo.series.id
      }
      return false
    },
    allowComment () {
      // 评论区是否开通，包括全站评论设置和文章评论设置
      if (!this.setting.allow_commenting) {
        // 系统未开放评论
        return false
      }
      if (!this.articleInfo.allow_comment) {
        // 文章未开放评论
        return false
      }
      return true
    },
    isBanned () {
      // 是否被禁言
      return this.userInfo && this.userInfo.id && (this.userInfo.banned_until < 0 || this.userInfo.banned_until * 1000 > Date.now())
    },
    reason () {
      if (!this.setting.allow_commenting) {
        // 系统未开放评论
        return '系统未开放评论'
      }
      if (!this.articleInfo.allow_comment) {
        // 文章未开放评论
        return '文章未开放评论'
      }
      if (this.isBanned) {
        return '你的账号已被禁言'
      }
      return ''
    },
    managePermission () {
      // 管理权限（管理包括精选和置顶）
      const article = this.articleInfo
      const user = this.userInfo

      if (!user) return false

      if (this.isSeriesArticle) {
        return user.slug === article.series.author.slug || (article.author_series_article_manage_on && user.slug === article.author.slug)
      }

      return user.role === 0
    },
    postType () {
      // 文章类型; 1: 免费文章; 2: 付费文章并且已购买; 3: 付费文章并且未购买预览页; 4: 短文章; 5: 付费文章试读页; 默认为免费文章
      if (this.articleInfo.thread) {
        return 4
      }
      if (this.articleInfo.is_free) {
        return 1
      } else {
        if (this.articleInfo.is_pay) {
          return 2
        } else {
          if (this.articleInfo.probation) {
            return 5
          }
          return 3
        }
      }
    }
  },

  methods: {
    toLogin () {
      this.$toLogin(this)
    },
    getCommentPermission (comment, parentComment) {
      // 回复权限
      if (this.isBanned) return false
      if (this.isSeriesArticle) return this.managePermission || (this.userInfo && parentComment.user.slug === this.userInfo.slug)
      return true
    },
    getDeletePermission (comment) {
      // 删除权限
      // 免费文章 判断有无删除权限
      if (this.isFreeArticle) {
        return this.managePermission ||
          (!this.isRecommendToHome && this.isAuthor) ||
          (this.userInfo && comment.user.slug === this.userInfo.slug)
      }
      // 付费文章
      return this.managePermission || (this.userInfo && comment.user.slug === this.userInfo.slug)
    },
    emitReply (comment, parentComment) {
      this.replyToComment.parentId = (parentComment && parentComment.id) || 0
      this.replyToComment.comment = comment
    },
    emitLike (value, id, parentId) {
      const url = !parentId ? '/comment/like/status/update' : '/comment/reply/like/status/update'
      this.$http({
        method: 'POST',
        url,
        data: {
          target_id: id,
          status: value
        }
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            type: 'success',
            message: '操作成功！'
          })
        }
      }).catch(error => {
        console.log(error)
        this.$toast({
          message: '操作失败！',
          type: 'error'
        })
      })
    },
    emitReport (id) {
      this.$ReportDialog({
        referenceId: id,
        type: 'comment'
      })
    },
    async emitDelete (value) {
      const { id, parentId, comment } = value
      try {
        let isKeepPlaceholder = true
        let isDeleteDirectly = true

        if (!parentId && (this.managePermission && comment.user.slug !== this.userInfo.slug)) {
          // 父评论删除时，管理员需要判断是否保留占位
          isDeleteDirectly = false
        }

        if (isDeleteDirectly) {
          // 直接删除
          await this.$confirm('是否删除该评论？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonClass: 'ss-default ss-small colorRed',
            cancelButtonClass: 'ss-default ss-small',
            type: 'warning'
          })
        } else {
          isKeepPlaceholder = await this.$keepCommentDeletedPlaceholder()
        }

        let url = !parentId ? `/comment/delete?reply_show=${isKeepPlaceholder}` : '/comment/reply/delete'
        let data = { id }
        if (this.isSeriesArticle) {
          if (this.managePermission) {
            url = !parentId ? `/series/article/comment/delete?reply_show=${isKeepPlaceholder}` : '/series/article/comment/reply/delete'
          } else {
            url = !parentId ? '/series/user/article/comment/delete' : '/series/article/comment/reply/delete'
          }
          data = {
            id,
            series_id: this.articleInfo.series.id
          }
          !!parentId && (data.comment_id = parentId)
        }
        const response = await this.$http({
          method: 'POST',
          url,
          data
        })
        if (response.error === 0) {
          this.$toast({
            message: `删除成功！`,
            type: 'success'
          })
          this.onDeleteSuccess(value)
        }
      } catch (error) {
        console.log(error)
        if (error === 'cancel' || error.message === 'cancel') {
          return
        }
        this.$toast({
          message: '操作失败！',
          type: 'error'
        })
      }
    },
    async onDeleteSuccess (value) {
      const { id, parentId } = value
      const index = parentId ? value.parentIndex : value.index
      // 直接替换
      const comment = await this.fetchComment('comment', parentId || id)
      if (comment) {
        this.comments.splice(index, 1, comment)
      } else {
        this.comments.splice(index, 1)
      }
    },
    async fetchComment (type, id) {
      // 获取当条评论
      const response = await this.$http({
        methods: 'GET',
        url: '/comment/info/get',
        params: {
          type,
          comment_id: id
        }
      })
      if (response.error === 0) {
        return response.data
      }
      return null
    },
    // 评论文章
    async onSubmitComment (value, files, callback) {
      let url = '/comment/article'
      let data = {
        article_id: this.articleInfo.id,
        comment: value,
        comment_files: files
      }
      if (this.isSeriesArticle) {
        // 栏目文章
        url = '/series/article/comment'
        data = {
          series_id: this.articleInfo.series.id,
          article_id: this.articleInfo.id,
          comment: value,
          comment_files: files
        }
      }

      try {
        // 评论公约
        await this.$CommentConvention({ userInfo: this.userInfo })

        const res = await this.$http({ method: 'POST', url, data })
        if (!res.data) {
          callback('fail')
          return
        }
        if (!res.data.success && res.data.status === 1) {
          // 评论中非法关键词
          this.keywordsIllegal = res.data.keywords
          this.$toast({ type: 'error', message: '评论中有违反社区规范的内容，请修改后再发布。' })
          callback('fail')
        } else if (res.data.success && res.data.status === 2) {
          this.$toast({ type: 'success', message: '你的评论正在审核，请稍候……' })
          callback('success')
        } else if (res.data.success && res.data.status === 3) {
          this.$toast({ type: 'success', message: '回复成功！' })
          this.commentBlur()
          callback('success')
          const comment = await this.fetchComment('comment', res.data.id)
          if (comment) {
            this.comments.splice(0, 0, comment)
          }
        }
      } catch (error) {
        console.log(error)
        callback('fail')
      }
    },
    // 回复评论
    async onSubmitReply (value, files, callback) {
      let url = '/comment/reply'
      let data = {
        article_id: this.articleInfo.id,
        comment: value,
        comment_files: files,
        comment_id: this.replyToComment.parentId || this.replyToComment.comment.id
      }
      if (this.isSeriesArticle) {
        // 栏目文章
        url = '/series/article/comment/reply'
        data = {
          series_id: this.articleInfo.series.id,
          article_id: this.articleInfo.id,
          comment: value,
          comment_id: this.replyToComment.parentId || this.replyToComment.comment.id,
          comment_files: files
        }
      }
      if (this.replyToComment.parentId) {
        data.reply_to_id = this.replyToComment.comment.id
      }
      try {
        // 评论公约
        await this.$CommentConvention({ userInfo: this.userInfo })

        const res = await this.$http({ method: 'POST', url, data })
        if (!res.data) {
          callback('fail')
          return
        }
        if (!res.data.success && res.data.status === 1) {
          // 评论中非法关键词
          this.keywordsIllegal = res.data.keywords
          this.$toast({ type: 'error', message: '评论中有违反社区规范的内容，请修改后再发布。' })
          callback('fail')
        } else if (res.data.success && res.data.status === 2) {
          this.$toast({ type: 'success', message: '你的评论正在审核，请稍候……' })
          this.onReplySuccess(this.replyToComment)
          this.commentBlur()
          this.replyToComment.value = ''
        } else if (res.data.success && res.data.status === 3) {
          this.$toast({ type: 'success', message: '回复成功！' })
          this.onReplySuccess(this.replyToComment)
          this.commentBlur()
          this.replyToComment.value = ''
          callback('success')
        }
      } catch (error) {
        console.log(error)
        callback('fail')
      }
    },
    async onReplySuccess (replyToComment) {
      // 刷新单条数据
      const id = replyToComment.parentId || replyToComment.comment.id
      const comment = await this.fetchComment('comment', id)
      if (comment) {
        const index = this.comments.findIndex(el => el.id === id)
        if (index > -1) {
          this.comments.splice(index, 1, comment)
        }
      }
    },
    onChange (value) {
      this.replyToComment.value = value
    },
    commentBlur () {
      this.replyToComment.parentId = 0
      this.replyToComment.comment = null
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/variable.styl'
.comment {
  .comment-container {
    width 100%
    max-width 644px
    margin 0 auto
  }

  >>> .ss-comment-block .disable-wrapper {
    background: var(--dark-bwb-2)!important;
  }
  >>> .ss-comment-block .wrapper .right-wrapper {
    line-height: inherit;
  }
  >>> .ss-comment-block .typing-wrapper .btn-wrapper {
    line-height: inherit;
  }

  .comment-item-inner-wrapper {
    >>> ._action {
      button {
        order: 3;
        cursor: url('~@/assets/images/pointer@1x.png') 7 0, pointer;
        color: var(--dark-bwb-8);
      }
      .date {
        order: 4;
      }
      .btn-reply {
        order: 2;
        .iconfont-comment {
          width: 16px;
          height: 16px;
          display: inline-block;
          background-color: var(--dark-bwb-8);
          mask: url("~@/assets/icons/comment.svg") no-repeat;
          mask-size: 100% 100%;

          &::before {
            display: none;
          }
        }
      }
      .btn-like {
        order: 1;
        .like {
          width: 16px;
          height: 16px;
          display: inline-block;
          background-color: var(--dark-bwb-8);
          mask: url("~@/assets/icons/like.svg") no-repeat;
          mask-size: 100% 100%;

          &::before {
            display: none;
          }
        }
        &.active {
          .like {
            mask: url("~@/assets/icons/like_fill.svg") no-repeat;
            background-color: var(--yellow-testv);
          }
        }
      }

      .btn-dislike,
      .btn-top,
      .btn-chose {
        display: none;
      }

      .iconfont ~ span {
        font-family: "DottedSongtiSquare";
      }
    }
    >>> ._content .wangEditor-txt,
    >>> .ss__user__nickname {
      color: var(--dark-bwb-8);
    }
    >>> .ss__user__identifier {
      display: none;
    }
    >>> .right-wrapper {
      display: none;
    }
  }

  .comment-reply-wrapper {
    padding 18px
    background var(--dark-bwb-2)
    margin-bottom 16px
    .text {
      color var(--dark-bwb-6)
    }
    a.join {
      color var(--red-t)!important
    }
  }
}

.comment-list-wrapper {
  .comment-item-wrapper {
    background var(--dark-bwb-2)
    margin 10px 0
    padding 18px

    .comment-children-wrapper {
      margin-left 38px

      .comment-item-inner-wrapper {
        margin 30px 0
        &:last-child {
          margin-bottom 0
        }
      }
    }
  }
}

.comment-child-reply-wrapper {
  padding 0 18px 18px
  margin-top: 20px;
  margin-left 8px
  @media (min-width: $screen-md) {
    margin-left: 52px;
  }
  >>> .ss-comment-block {
    border: 1px solid var(--dark-bwb-3);
    padding: 14px;
    border-radius: 4px;
    .ss__user__identifier {
      display: none;
    }
    .typing-wrapper-header {
      color: var(--dark-bwb-8);
    }
    a {
      color: inherit;
    }
  }
}
</style>

<style lang="stylus">
.ss-comment-block {
  .wrapper {
    .right-wrapper {
      display: flex;
      align-items: center;
      .typing-wrapper {
        width: 100%;
        .textarea {
          color: var(--dark-bwb-8);
        }
        .btn-wrapper {
          .btn-comment {
            background: var(--yellow-testv);
            color: var(--dark-bwb-0);
            border-radius: 4px;
            letter-spacing: normal;
          }
          .btn-comment-pic {
            background: var(--yellow-testv);
            color: var(--dark-bwb-0);
            border-radius: 4px;
            .iconfont-comment_pic {
              width: 20px
              height: 20px;
              background-image: url("~@/assets/icons/pic.svg");
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              &::before {
                content: '';
              }
            }
          }
          .norm {
            white-space: nowrap;
          }
        }
      }
    }
  }
  .comment-placeholder,
  .typing-wrapper .typing-wrapper-header,
  .typing-wrapper .typing-wrapper-header .nickname {
    color: var(--dark-bwb-8)!important;
  }
}

.ss__user__identifier {
  display: none!important;
}
</style>